module.exports = __webpack_public_path__ + "static/media/ee.2cb22dc7.svg";